import { Roles } from '../../../../../utils/enums'
import { canAccess } from '../../../../../utils/validate/canaccess'

const userCannotSelectcUsers = () => {
  return !!canAccess([Roles.PARTNER])
}

export { userCannotSelectcUsers }
